import ai from './ai.service';
import appContext from './appContext.service';
import auth from './auth.service';
import billing from './billing.service';
import collection from './collection.service';
import conversation from './conversation.service';
import corrections from './corrections.service';
import course from './course.service';
import email from './email.service';
import mindItem from './mindItem.service';
import notification from './notification.service';
import pdf from './pdf.service';
import product from './product.service';
import recommendations from './recommendations.service';
import registration from './registration.service';
import search from './search.service';
import text from './text.service';
import track from './track.service';
import user from './user.service';

export default {
	appContext,
	ai,
	auth,
	billing,
	collection,
	course,
	email,
	mindItem,
	notification,
	product,
	recommendations,
	registration,
	text,
	track,
	user,
	search,
	conversation,
	corrections,
	pdf,
};
